import React from 'react';
import { cn } from 'lib/utils';

export interface ExamBarProps {
    /** 0–100. */
    pct: number;
    /** Height, track colour and rounding (defaults: grey track, fully rounded). */
    className?: string;
}

/** Flat ink progress bar. Decorative: the count next to it carries the value. */
export function ExamBar({ pct, className }: ExamBarProps) {
    const clamped = Math.min(100, Math.max(0, Number.isFinite(pct) ? pct : 0));
    return (
        <span aria-hidden className={cn('block overflow-hidden rounded-full bg-muted', className)}>
            <span
                className="block h-full w-full rounded-[inherit] bg-foreground transition-transform duration-300 ease-out"
                style={{ transform: `translateX(${clamped - 100}%)` }}
            />
        </span>
    );
}

export default ExamBar;
